import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as service from '../../../services/inquiryEmailTemplate.service';
import Breadcrums from '../../../common/breadcrumbs';
import { SWAL_SETTINGS } from '../../../../../utils/Constants';
import { Placeholder } from 'rsuite';

const InquiryEmailTemplateEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [title, setTitle] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const breadcrumbs = [
    { title: 'Dashboard', url: '/admin/dashboard' },
    { title: 'Inquiry Email Templates', url: '/admin/cms/inquiry-email-templates/list/1' },
    { title: 'Edit', url: '' },
  ];

  useEffect(() => {
    service.Details(params.id).then(res => {
      if (res.data) {
        setTitle(res.data.title || '');
        setSubject(res.data.subject || '');
        setBody(res.data.body || '');
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [params.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append('o_id', params.id);
      fd.append('title', title);
      fd.append('subject', subject);
      fd.append('body', body);
      const res = await service.Edit(fd);
      if (res.success) {
        Swal.fire({ icon: 'success', text: res.message, ...SWAL_SETTINGS })
          .then(() => navigate('/admin/cms/inquiry-email-templates/list/1'));
      } else {
        Swal.fire({ icon: 'error', text: res.message, ...SWAL_SETTINGS });
      }
    } catch (err) {
      Swal.fire({ icon: 'error', text: 'Something went wrong', ...SWAL_SETTINGS });
    }
    setSubmitting(false);
  };

  if (loading) return <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active rows={7} />;

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">Edit Inquiry Email Template</h6>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Title <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" value={title}
                    onChange={e => setTitle(e.target.value)} required />
                </div>
                <div className="form-group mt-3">
                  <label>Subject <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" value={subject}
                    onChange={e => setSubject(e.target.value)} required />
                </div>
                <div className="form-group mt-3">
                  <label>Body <span className="text-danger">*</span></label>
                  <textarea className="form-control" rows={8} value={body}
                    onChange={e => setBody(e.target.value)} required />
                </div>
                <div className="mt-4">
                  <button type="submit" className="btn btn-primary me-2" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Update'}
                  </button>
                  <button type="button" className="btn btn-dark"
                    onClick={() => navigate('/admin/cms/inquiry-email-templates/list/1')}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiryEmailTemplateEdit;
